import { render, staticRenderFns } from "./Component-Dropdown.vue?vue&type=template&id=b47dd58e"
import script from "./Component-Dropdown.vue?vue&type=script&lang=js"
export * from "./Component-Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports